import parkezeMark from '@/assets/parkeze-mark.png'

/**
 * The Parkeze signature under an operator's brand (logbook decision 26): the
 * Parkeze mark at the text's height, then "Powered by Parkeze", in the muted
 * text color, linking to parkeze.com. Shown on phones too, and never larger
 * than the operator's identity in the header.
 */
export function PoweredByParkeze() {
  return (
    <a
      href="https://parkeze.com"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 leading-none text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap"
    >
      <img src={parkezeMark} alt="" className="h-[1em] w-[1em]" />
      Powered by Parkeze
    </a>
  )
}
